var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutPickupMidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "122px",
    viewBox: "0 0 272 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4:284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.765 18.5015L205.864 50.7693L213.23 54.398L229.131 22.1302L221.765 18.5015Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.105 26.7012L218.657 63.3109L223.608 69.8609L272.056 33.2512L267.105 26.7012Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20772 98.8455L-0.302734 106.916L51.1097 116.536L52.6202 108.466L1.20772 98.8455Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7949 37.414L13.1084 42.1793L39.7362 79.533L46.4226 74.7677L19.7949 37.414Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.768 197.793C159.133 197.796 155.647 199.242 153.076 201.813C150.505 204.383 149.059 207.869 149.056 211.504C149.059 215.14 150.505 218.625 153.076 221.196C155.647 223.766 159.133 225.212 162.768 225.215C166.404 225.212 169.89 223.766 172.461 221.196C175.032 218.625 176.478 215.14 176.481 211.504C176.475 207.87 175.028 204.386 172.458 201.816C169.888 199.246 166.403 197.799 162.768 197.793ZM162.768 217.005C161.309 217.005 159.91 216.425 158.878 215.394C157.847 214.362 157.267 212.963 157.267 211.504C157.27 210.046 157.851 208.649 158.882 207.618C159.913 206.587 161.31 206.006 162.768 206.003C164.227 206.006 165.624 206.587 166.655 207.618C167.686 208.649 168.267 210.046 168.27 211.504C168.267 212.962 167.686 214.359 166.655 215.39C165.624 216.421 164.227 217.002 162.768 217.005Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0498 27.6681L102.51 257L236.234 229.344L188.774 0L55.0498 27.6681ZM108.88 247.3L64.7624 34.0485L182.416 9.71142L226.545 222.963L108.88 247.3Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3986 143.689L143.179 134.012L194.874 157.47L189.243 124.477L199.097 122.448L190.886 82.969L88.1992 104.21L96.3986 143.689ZM184.551 92.6687L189.384 116.068L179.824 118.05L184.176 143.607L144.199 125.427L102.838 133.989L97.9941 110.59L184.551 92.6687Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.522 26.2482L108.121 32.3777L109.603 40.4529L143.004 34.3234L141.522 26.2482Z",
    fill: "#6A6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4:284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 257,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPickupMidIcon);
export default __webpack_public_path__ + "static/media/about-pickup-mid-icon.b2b3395ecdd928edc1b6088794c6253b.svg";
export { ForwardRef as ReactComponent };